"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash")),
    genericInstall = function genericInstall(e) {
  e._ = _lodash["default"], Object.defineProperties(e.prototype, {
    _: {
      get: function get() {
        return _lodash["default"];
      }
    }
  });
},
    VueLodash = {
  install: function install(e, t) {
    t && t.name && (e[t.name] = _lodash["default"], Object.defineProperties(e.prototype, _defineProperty({}, t.name, {
      get: function get() {
        return _lodash["default"];
      }
    }))), genericInstall(e), e.mixin({
      mounted: function mounted() {}
    }), "undefined" != typeof window && window.Vue && window.Vue.use(VueLodash);
  }
},
    _default = VueLodash;

exports["default"] = _default;